import * as mutationTypes from './mutation-types'

import { filterItems, prepareData } from './helpers'

const ReconciliationTexts = {
  state() {
    return {
      data: [],
    }
  },

  getters: {
    processedReconciliationTexts: ({ data }, _getters, { query }) => {
      return filterItems(data, query.currentQuery)
    },
  },

  mutations: {
    [mutationTypes.SET_RECONCILIATION_TEXTS_DATA](state, data) {
      state.data = prepareData(data, 'ReconciliationText')
    },
  },
}

export default ReconciliationTexts
